__webpack_require__.p = "https://wp-static.smartkarma.com/_next/";